__turbopack_context__.v({
  "ATWcontainer": "HomePage-module-scss-module__-9ehDq__ATWcontainer",
  "button": "HomePage-module-scss-module__-9ehDq__button",
  "cardWrapper": "HomePage-module-scss-module__-9ehDq__cardWrapper",
  "homeContainer": "HomePage-module-scss-module__-9ehDq__homeContainer",
  "secTextWrapper": "HomePage-module-scss-module__-9ehDq__secTextWrapper",
  "secTitleWrapper": "HomePage-module-scss-module__-9ehDq__secTitleWrapper",
  "sectionContainer": "HomePage-module-scss-module__-9ehDq__sectionContainer",
  "socialLink": "HomePage-module-scss-module__-9ehDq__socialLink",
  "socialWrapepr": "HomePage-module-scss-module__-9ehDq__socialWrapepr",
  "textWrapper": "HomePage-module-scss-module__-9ehDq__textWrapper",
  "titleWrapper": "HomePage-module-scss-module__-9ehDq__titleWrapper",
});
